import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/msalConfig';

const msalInstance = new PublicClientApplication(msalConfig);

// MSAL Browser v5 requires initialize() to be awaited before any MSAL
// operations. This is critical for popup flow: the popup loads /auth-popup,
// MsalProvider calls handleRedirectPromise() on mount, detects the popup
// context, exchanges the auth code, posts back to the opener, and closes.
msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
  reportWebVitals();
});
